import React, { useMemo } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import _ from 'lodash'
import { useGetAllActiveMerchantsIdAndNameCachedQuery } from '../../../redux/commonApiCalls'

/**
 * Merchant search box (value = merchant id or null). ptlOnly limits it to PTL-flagged merchants; billing covers every
 * merchant with B2B shipments (D15), so pages that bill offer all.
 */
export default function MerchantPicker({ value, onChange, ptlOnly = false, label = 'Client', placeholder = 'All clients', size = 'small', sx }) {
  const { data: merchants = [], isLoading } = useGetAllActiveMerchantsIdAndNameCachedQuery()
  const options = useMemo(() => {
    let list = merchants.filter((m) => m.is_deleted === '0')
    // the selected merchant always stays in the list, even when it is not PTL-flagged
    if (ptlOnly) list = list.filter((m) => m.isPTLMerchant === true || m.id === value)
    return _.orderBy(list, 'name').map((m) => ({ value: m.id, label: m.companyName ? `${m.name} (${m.companyName})` : m.name, ptl: m.isPTLMerchant === true }))
  }, [merchants, ptlOnly, value])
  const selected = options.find((o) => o.value === value) || null
  return (
    <Autocomplete
      size={size}
      sx={{ minWidth: 260, ...sx }}
      options={options}
      value={selected}
      loading={isLoading}
      onChange={(_e, o) => onChange(o ? o.value : null)}
      isOptionEqualToValue={(a, b) => a.value === b.value}
      renderInput={(p) => <TextField {...p} label={label} placeholder={placeholder} InputLabelProps={{ ...p.InputLabelProps, shrink: true }} />}
    />
  )
}
